import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getGroups } from '../../../../global/ducks/mlps-api';
import { getGroupAdminsList } from '../../../../global/ducks/wam-api';
import { TcsmStates } from '../../../../root/tcsm-model';
import { dispatchSetGroupAdmins } from '../institution-officers/institution-officers-slices';
import { GroupsState } from './groups-model';
import { setGroups } from './groups-slice';

export function useInsuranceGroups() {
    const dispatch = useDispatch();
    const groupsState = useSelector<TcsmStates, GroupsState>(state => state.groupsState);

    useEffect(() => {
        if (!groupsState.groupsLoaded) {
            dispatch(getGroups(
                // success
                (response) => {
                    dispatch(setGroups(response.data));
                    if (response.data?.length === 1) {
                        dispatch(getGroupAdminsList(response?.data[0].group_id, (res) => {
                            dispatchSetGroupAdmins(res, dispatch);
                        }));
                    }
                },
                // failure
                () => {
                    dispatch(setGroups([]));
                }));
        }
    }, []);


    return groupsState.groupsLoaded;
}
